import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import moment from "moment";
import { addCommas } from "../../../utils/utils";

const styles = () => ({
  root: {
    padding: 20,
    borderBottom: '1px solid #00000026',
    display: "flex",
    justifyContent: 'space-between',
    alignItems: 'center',
    background: "#FFFFFF",
  },

  left: {
    display: "flex",
    flexDirection: "column",
  },

  date: {
    fontSize: 15,
    fontWeight: 700,
    marginBottom: 8,
  },

  details: {
    display: "flex",
    fontSize: 13,
    color: "#71737B",
  },

  detailItem: {
    marginRight: 24,
  },

  right: {
    display: "flex",
    alignItems: 'center',
  },

  btn: {
    padding: '10px 18px',
    height: "33px",
    minWidth: "62px",
    borderRadius: "2px",
    fontSize: "13px",
    textTransform: 'none',
    whiteSpace: 'nowrap',
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
  },
});

class DownloadHistoryItem extends React.Component {
  render() {
    const { classes, order } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.left}>
          <div className={classes.date}>
            {moment(order.instructed_at).format("YYYY/MM/DD HH:mm")}
          </div>
          <div className={classes.details}>
            <span className={classes.detailItem}>ダウンロード者: {order.ownership_user_name || "-"}</span>
            <span className={classes.detailItem}>ダウンロード件数: {addCommas(order.export_count)}件</span>
          </div>
        </div>
        <div className={classes.right}>
          <Button
            className={classes.btn}
            onClick={() => this.props.onShowDetail(order)}
          >
            明細を見る
          </Button>
        </div>
      </div>
    );
  }
}

DownloadHistoryItem.propTypes = {
  classes: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  onShowDetail: PropTypes.func.isRequired,
};

export default withStyles(styles)(DownloadHistoryItem);



// WEBPACK FOOTER //
// ./src/components/DownloadHistory/items/DownloadHistoryItem.jsx